import { Key, useState } from 'react';
import { CheckboxForm, InputText, Text } from '@msc-b2c/shared-components';
import { MSCVoyagersClubStepProps } from '@msc-b2c/interfaces/interfaces';
import styles from './mscvoyagersclubstep.module.scss';
import {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
} from 'react-hook-form';
import { getKeyboardType, validateFormField } from '@msc-b2c/shared-utils';
import Checklist from './Checklist';
import { voyagersClubToggleOptionsEnum } from '@msc-b2c/interfaces/enums';

export function MSCVoyagersClubStep({
  defaultToggleOptions,
  toggleOneVisibility,
  mscVoyagersClubMemberLabel,
  mscVoyagersClubMemberInputLabel,
  mscVoyagersClubMemberInputPlaceholder,
  validationRulesMscVoyagersClubNumber,
  joinMscVoyagersClubLabel,
  joinMscVoyagersClubSubtitle,
  bulletPointIcon,
  bulletPointsForMscVoyagersClub,
  policyDescription,
  register,
  trigger,
  errors,
  clearErrors,
  setValue,
}: MSCVoyagersClubStepProps & {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  clearErrors: UseFormClearErrors<any>;
  trigger: UseFormTrigger<any>;
  setValue: UseFormSetValue<any>;
}) {
  const [alreadyMemberToggle, setAlreadyMemberToggle] = useState(
    defaultToggleOptions === voyagersClubToggleOptionsEnum.ALREADY_MEMBER_TOGGLE
  );
  const [joinClubToggle, setJoinClubToggle] = useState(
    defaultToggleOptions === voyagersClubToggleOptionsEnum.JOIN_CLUB_TOGGLE
  );

  const handleAlreadyMemberToggle = () => {
    const alreadyMemberToggleUpdate = !alreadyMemberToggle;
    if (alreadyMemberToggleUpdate && joinClubToggle) {
      setValue('createNewMembership', false);
      setJoinClubToggle(false);
    }
    setAlreadyMemberToggle(alreadyMemberToggleUpdate);
  };

  const handleJoinClubToggle = () => {
    const joinClubToggleUpdate = !joinClubToggle;
    if (joinClubToggleUpdate && alreadyMemberToggle) {
      setValue('hasMembership', false);
      setAlreadyMemberToggle(false);
    }
    setJoinClubToggle(joinClubToggleUpdate);
  };

  return (
    <div className={styles['stepContainer']}>
      {toggleOneVisibility && (
        <div className={styles['stepContainer__toggle']}>
          <div className={styles['stepContainer__toggle__one']}>
            <Text
              text={mscVoyagersClubMemberLabel}
              tagHtml="span"
              styleOption="cmp-text__normal"
            />
            <CheckboxForm
              index={1}
              name={'hasMembership'}
              onChange={handleAlreadyMemberToggle}
              register={register}
              errors={errors}
              clearErrors={clearErrors}
              checked={alreadyMemberToggle}
              styleOptions="cmp-form-options--toggle"
            />
          </div>
          {alreadyMemberToggle && (
            <div>
              <InputText
                inputType={getKeyboardType(validationRulesMscVoyagersClubNumber)}
                register={register}
                errors={errors}
                index={1}
                label={mscVoyagersClubMemberInputLabel}
                placeholder={mscVoyagersClubMemberInputPlaceholder}
                clearErrors={clearErrors}
                name={'membership.number'}
                validation={{
                  validate: (value) => {
                    return validateFormField(value, validationRulesMscVoyagersClubNumber || []);
                  },
                  onBlur: () => {
                    trigger(`membership.number`);
                  },
                }}
              />
            </div>
          )}
        </div>
      )}
      <hr className={styles['stepContainer__separator']} />
      <div className={styles['stepContainer__toggle']}>
        <div className={styles['stepContainer__toggle__two']}>
          <Text
            text={joinMscVoyagersClubLabel}
            tagHtml="span"
            styleOption="cmp-text__normal"
          />
          <CheckboxForm
            index={2}
            name={'createNewMembership'}
            onChange={handleJoinClubToggle}
            register={register}
            errors={errors}
            clearErrors={clearErrors}
            checked={joinClubToggle}
            styleOptions="cmp-form-options--toggle"
          />
        </div>
        <div className={styles['secondToggleContainer']}>
          <Text
            text={joinMscVoyagersClubSubtitle}
            styleOption={joinClubToggle ? 'cmp-text__normal' : 'cmp-text__normal disabled'}
            tagHtml="span"
          />
          {bulletPointsForMscVoyagersClub?.map((point: { bulletPoint: string }, index: Key) => (
            <Checklist
              key={`${index}-${point.bulletPoint}`}
              text={point.bulletPoint}
              icon={bulletPointIcon}
              toggleOpen={joinClubToggle}
            />
          ))}
          <Text
            text={policyDescription}
            styleOption={`privacy-terms-conditions ${
              joinClubToggle ? 'cmp-text__small' : 'cmp-text__small disabled'
            }`}
            tagHtml="span"
          />
        </div>
      </div>
    </div>
  );
}
export default MSCVoyagersClubStep;
